// constants/FactureConfig.js

// Échelle du PDF pour la facture
export const FACTURE_PDF_SCALE = 1;

// Offset de la taille de police pour la facture
export const FACTURE_FONT_SIZE_OFFSET = 1;

// Correction verticale pour la facture
export const FACTURE_Y_OFFSET_CORRECTION = 0;

// Correction verticale spécifique pour la génération du PDF de facture
export const FACTURE_Y_OFFSET_PDF_GENERATION = -92;

// Correction horizontale pour la génération du PDF de facture
export const FACTURE_X_OFFSET_PDF_GENERATION = -150;

// Validation des constantes
if (typeof FACTURE_PDF_SCALE !== 'number' || FACTURE_PDF_SCALE === 0) {
  console.error('FACTURE_PDF_SCALE ne doit pas être égal à zéro');
}

if (typeof FACTURE_FONT_SIZE_OFFSET !== 'number' || FACTURE_FONT_SIZE_OFFSET <= 0) {
  console.error('FACTURE_FONT_SIZE_OFFSET doit être un nombre positif');
}

console.log("FACTURE_Y_OFFSET_CORRECTION utilisé :", FACTURE_Y_OFFSET_CORRECTION); 